import React from 'react'
import { Box } from '@mui/material'

interface SignInLayoutProps {
  children: React.ReactNode
  backgroundImage?: string
}

export default function SignInLayout({ children, backgroundImage }: SignInLayoutProps) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        width: '100%',
        // Mobile: Use background image as full background
        backgroundImage: {
          xs: backgroundImage ? `url(${backgroundImage})` : 'none',
          md: 'none'
        },
        backgroundSize: { xs: 'cover', md: 'auto' },
        backgroundPosition: { xs: 'center', md: 'initial' },
        backgroundRepeat: { xs: 'no-repeat', md: 'repeat' },
        backgroundColor: '#000'
      }}
    >
      {/* Left Side - Background Image (Desktop only) */}
      <Box
        sx={{
          display: { xs: 'none', md: 'block' },
          width: { xs: 0, md: '50%' },
          position: 'relative',
          backgroundColor: '#000',
          backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      />

      {/* Right Side - Content */}
      <Box
        sx={{
          width: { xs: '100%', md: '50%' },
          backgroundColor: { xs: 'transparent', md: '#000' },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: { xs: 3, md: 4 }
        }}
      >
        <Box sx={{ maxWidth: '400px', width: '100%' }}>{children}</Box>
      </Box>
    </Box>
  )
}
